'use strict';

var angular = require('angular');

/*@ngInject*/
module.exports = function($window) {
    var $win = angular.element($window); // wrap window object as jQuery object

	return {
		restrict: 'A',
		scope: {
			method: '&runWhenPassedTop'
		},
		link: function (scope, element, attrs) {
			var expressionHandler = scope.method();
			var topOffset = attrs.runWhenPassedTopOffset || 0;

			if ($window.innerWidth < 840) {
					topOffset = 680;
				}

			$win.on('scroll', function (e) {
				
				if ($win.scrollTop() >= topOffset) {
				
					expressionHandler(true);
				} 
				else {

					expressionHandler(false);
				}
			});
		}
	};
};